import request from "../axios";

export const getPaymentPlans = () => request.get('/api/utils/payment-plans');